var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiEnhancedLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 218,
    viewBox: "0 0 180 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.789 100.068C179.479 98.903 178.85 97.824 177.958 96.9268C177.067 96.0296 175.939 95.3421 174.676 94.9252L115.772 75.2896L130.761 8.65924C131.101 7.11112 130.864 5.50689 130.088 4.08863C129.311 2.67038 128.036 1.51505 126.456 0.797003C124.876 0.0789502 123.076 -0.16287 121.327 0.108034C119.579 0.378937 117.977 1.14786 116.763 2.29878L2.24658 111.335C1.31649 112.206 0.643648 113.268 0.288173 114.427C-0.0673021 115.585 -0.094341 116.804 0.209474 117.974C0.513289 119.144 1.13849 120.228 2.02923 121.131C2.91997 122.034 4.0485 122.727 5.314 123.147L64.2391 142.783L49.2905 209.341C48.9511 210.889 49.1875 212.493 49.9641 213.911C50.7406 215.33 52.0152 216.485 53.5954 217.203C55.1757 217.921 56.9758 218.163 58.7243 217.892C60.4727 217.621 62.0746 216.852 63.2882 215.701L177.805 106.665C178.718 105.794 179.377 104.737 179.723 103.586C180.069 102.436 180.091 101.228 179.789 100.068Z",
    fill: "#FCC33D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEnhancedLightning);
export default __webpack_public_path__ + "static/media/AI-Enhanced-Lightning.32502ec6b105f0a97f51f1030ad3fb8d.svg";
export { ForwardRef as ReactComponent };